import { useRef, useState, useCallback, useLayoutEffect } from 'react'

import { IS_RTL_DIRECTION } from 'consts'

import * as Styled from './styled'
import FlatTab from './flat-tab'
import { IFlatTabDataWithText } from './interfaces'

interface IProps {
  dataWithTexts?: IFlatTabDataWithText[]
  defaultActiveTabName: string
  isFontPopup?: boolean
  withoutPadding?: boolean
  areHoverStylesUnset?: boolean
  onCurrentItemClick: (name: string) => void
  height?: number
}
const CORNER_BORDER_WIDTH = 1

const FlatTabbar: React.FC<IProps> = ({
  dataWithTexts,
  withoutPadding = false,
  areHoverStylesUnset,
  defaultActiveTabName,
  onCurrentItemClick,
  height = 40
}) => {
  const [tabbarWidth, setTabbarWidth] = useState(0)
  const activeTabRef = useRef<null | HTMLDivElement>(null)
  const tabbarRef = useRef<null | HTMLDivElement>(null)

  const handleTabClick = useCallback(
    (name: string) => {
      const activeTabStyleObject = activeTabRef.current?.style

      if (activeTabStyleObject && !activeTabStyleObject.transition) {
        activeTabStyleObject.transition = 'ease-in 0.2s'
      }
      onCurrentItemClick(name)
    },
    [onCurrentItemClick]
  )

  const data = dataWithTexts || []
  const activeTabIndex = data.findIndex(
    tab => tab.name === defaultActiveTabName
  )

  const tabWidth = (tabbarWidth - CORNER_BORDER_WIDTH) / data.length

  const TabList = dataWithTexts?.map(tab => {
    return (
      <FlatTab
        name={tab.name}
        isActive={defaultActiveTabName === tab.name}
        areHoverStylesUnset={areHoverStylesUnset}
        text={tab.text}
        onClick={handleTabClick}
        tabWidth={tabWidth}
        key={tab.name} // TODO: @gev-davtyan-rf check if you couldn't define unique id for each item
        height={height}
      />
    )
  })

  useLayoutEffect(() => {
    if (tabbarRef.current) {
      const tabbarWidth = tabbarRef.current.offsetWidth
      setTabbarWidth(tabbarWidth)
    }
  }, [])

  return (
    <Styled.FlatTabbarWrapper
      $height={height}
      $withoutPadding={withoutPadding}
      $isTabbarVisible={!!tabbarWidth}
    >
      <Styled.Tabbar ref={tabbarRef}>
        {TabList}
        {tabbarWidth && (
          <Styled.ActiveTab
            $height={height}
            $activeTabIndex={activeTabIndex}
            $isRTLDirection={IS_RTL_DIRECTION}
            $tabWidth={tabWidth}
            ref={activeTabRef}
          />
        )}
      </Styled.Tabbar>
    </Styled.FlatTabbarWrapper>
  )
}

export default FlatTabbar
